import { Site } from '@envato/foundation-types'

const experimentConfig = {
  categoryRedesignAJPhase2Experiment: {
    experimentId: 'TgTNWsiYTvGLI0COC-6iqQ',
    running: true,
    loadingCover: true,
    sites: [Site.audiojungle],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      }
    }
  },
  categoryRedesignCCPhase2Experiment: {
    experimentId: '5p9h_BDAROmGAQYmmamDew',
    running: true,
    loadingCover: true,
    sites: [Site.codecanyon],
    variants: {
      0: {
        categoryPageBlocksB: false
      },
      1: {
        categoryPageBlocksB: false
      },
      2: {
        categoryPageBlocksB: true
      },
      3: {
        categoryPageBlocksB: true
      }
    }
  },
  authorDiscountingItemsPhase2: {
    experimentId: 'Imkz6yaTRneKcf0pbDUlWw',
    running: false,
    loadingCover: true,
    sites: [Site.audiojungle, Site.videohive],
    variants: {
      0: {
        showSaleMessage1: false,
        showSaleMessage2: false,
        showBeforeAfterPricing: false,
        showSavingsPercentage: false,
        showSavingsAmount: false
      },
      1: {
        showSaleMessage1: false,
        showSaleMessage2: false,
        showBeforeAfterPricing: false,
        showSavingsPercentage: false,
        showSavingsAmount: false
      },
      2: {
        showSaleMessage1: true,
        showSaleMessage2: false,
        showBeforeAfterPricing: false,
        showSavingsPercentage: false,
        showSavingsAmount: false
      },
      3: {
        showSaleMessage1: true,
        showSaleMessage2: false,
        showBeforeAfterPricing: false,
        showSavingsPercentage: false,
        showSavingsAmount: false
      },
      4: {
        showSaleMessage1: true,
        showSaleMessage2: false,
        showBeforeAfterPricing: true,
        showSavingsPercentage: false,
        showSavingsAmount: false
      },
      5: {
        showSaleMessage1: true,
        showSaleMessage2: false,
        showBeforeAfterPricing: true,
        showSavingsPercentage: false,
        showSavingsAmount: false
      },
      6: {
        showSaleMessage1: true,
        showSaleMessage2: false,
        showBeforeAfterPricing: true,
        showSavingsPercentage: true,
        showSavingsAmount: false
      },
      7: {
        showSaleMessage1: true,
        showSaleMessage2: false,
        showBeforeAfterPricing: true,
        showSavingsPercentage: true,
        showSavingsAmount: false
      },
      8: {
        showSaleMessage1: true,
        showSaleMessage2: false,
        showBeforeAfterPricing: true,
        showSavingsPercentage: false,
        showSavingsAmount: true
      },
      9: {
        showSaleMessage1: true,
        showSaleMessage2: false,
        showBeforeAfterPricing: true,
        showSavingsPercentage: false,
        showSavingsAmount: true
      },
      10: {
        showSaleMessage1: false,
        showSaleMessage2: true,
        showBeforeAfterPricing: true,
        showSavingsPercentage: true,
        showSavingsAmount: false
      },
      11: {
        showSaleMessage1: false,
        showSaleMessage2: true,
        showBeforeAfterPricing: true,
        showSavingsPercentage: true,
        showSavingsAmount: false
      }
    }
  },
  categoryPageElementsBlockVH: {
    experimentId: 'neL6UBl6QM-075iakKCxUA',
    running: true,
    loadingCover: true,
    sites: [Site.videohive],
    variants: {
      0: {
        categoryPageBlocksB: false
      },
      1: {
        categoryPageBlocksB: false
      },
      2: {
        categoryPageBlocksB: true
      },
      3: {
        categoryPageBlocksB: true
      },
      4: {
        categoryPageBlocksB: true
      },
      5: {
        categoryPageBlocksB: true
      }
    }
  },
  categoryPageElementsBlockGR: {
    experimentId: '-nbomKMpRo-o422kNe1jpg',
    running: false,
    loadingCover: true,
    sites: [Site.graphicriver],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true
      }
    }
  },
  categoryPageElementsBlockTF: {
    experimentId: 'tDmLiaB-RACY6uDAIrm2aQ',
    running: false,
    loadingCover: true,
    sites: [Site.themeforest],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      6: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      },
      7: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      }
    }
  },
  categoryPageElementsBlockCC: {
    experimentId: 'MAQHi6cdSBO4n4x5qBV8Zg',
    running: false,
    loadingCover: true,
    sites: [Site.codecanyon],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      6: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      },
      7: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      }
    }
  },
  newSearchResults: {
    experimentId: 'ZxxtjOzCTy2PfJXMQFaJxQ',
    running: false,
    loadingCover: false,
    variants: {
      0: {
        fetchSearchResultsRetry: true,
        newSearchResults: false
      },
      1: {
        fetchSearchResultsRetry: true,
        newSearchResults: false
      },
      2: {
        fetchSearchResultsRetry: true,
        newSearchResults: true
      },
      3: {
        fetchSearchResultsRetry: true,
        newSearchResults: true
      }
    }
  },
  searchPageLoadTime: {
    experimentId: 'NPGcpullQtWWrbR0RhFz3w',
    running: false,
    loadingCover: false,
    variants: {
      0: {
        fetchSearchResultsRetry: false
      },
      1: {
        fetchSearchResultsRetry: false
      },
      2: {
        fetchSearchResultsRetry: true
      },
      3: {
        fetchSearchResultsRetry: true
      },
      4: {
        fetchSearchResultsRetry: true,
        prolongLoadingStatus: true
      },
      5: {
        fetchSearchResultsRetry: true,
        prolongLoadingStatus: true
      }
    }
  }
}

export default experimentConfig
